import { useMutation, useQueryClient } from '@tanstack/react-query';
import { container } from '@/app/container';
import { UsersRepositoryToken } from '../../di/tokens';
import type {
  ProvisionScopedUserInput,
  ProvisionUserInput,
} from '../../domain/entities/user.entity';

export function useCreateUser() {
  const queryClient = useQueryClient();
  const repository = container.resolve(UsersRepositoryToken);
  return useMutation({
    mutationFn: (input: ProvisionUserInput) => repository.provision(input),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['users'] });
    },
  });
}

/** A rota única do iamEditor, da lista e do detalhe. */
export function useProvisionScopedUser() {
  const queryClient = useQueryClient();
  const repository = container.resolve(UsersRepositoryToken);
  return useMutation({
    mutationFn: (input: ProvisionScopedUserInput) =>
      repository.provisionScopedUser(input),
    onSuccess: () => {
      // `['users']` cobre a lista e o detalhe (`['users', userId]`).
      void queryClient.invalidateQueries({ queryKey: ['users'] });
    },
  });
}
